export default __webpack_public_path__ + "static/media/ren.05541e8b.png";